import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Make sure you have this file
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

reportWebVitals();